/**
 * Since this package is meant for web consumption the axios
 * package imported below will not be recognized;
 * Note to include axios CDN in the html file -
 * otherwise axios will not be recognized
 * Ex:
 * <script src="https://unpkg.com/axios/dist/axios.min.js"></script>
 */
import Constants from "./constants";
import AxiosSingleton from "./AxiosSingleton";
import { WebClientStore } from "web-client-store";
var SESSION_KEYS = Constants.SESSION_KEYS;
var console = Constants.consoleWrapper(false);
var ApiHandler = /** @class */ (function () {
    function ApiHandler() {
        var _this = this;
        // private comp: any;
        this.silentMode = false;
        this.componentDidMount = function () {
            //this.nav.componentDidMount();
        };
        this.componentWillUnmount = function () {
            //this.nav.componentWillUnmount();
        };
        this.setSilentMode = function (mode) {
            if (mode === void 0) { mode = false; }
            return (_this.silentMode = mode);
        };
        this.setInstance = function (instance) {
            _this.instance = instance;
        };
        this.getInstance = function () {
            return _this.instance;
        };
        this.showEnque = function (msg, variant) { }; // this.props.enqueueSnackbar(msg, {variant});
        this.showSuccess = function (msg) { }; ////this.showEnque(msg, 'success');
        this.showInfo = function (msg) { }; // //this.showEnque(msg, 'info');
        this.showWarn = function (msg) { }; // //this.showEnque(msg, 'warning');
        this.showError = function (msg) { }; // //this.showEnque(msg, 'error');
        this.handleError = function (error, msg) {
            console.error(error);
            if (msg)
                console.debug(msg);
            msg = null;
            try {
                if (error.response.data.message)
                    msg = error.response.data.message;
            }
            catch (err) { }
            try {
                if (error.response.data.error)
                    msg = error.response.data.error;
            }
            catch (err) { }
            if (msg)
                console.info("Server response", msg);
            // //this.showError(msg);
            // return Promise.reject('error');
        };
        this.defaultErrorHandler = function (err, reject, errMsg) {
            if (errMsg === void 0) { errMsg = "An unknown error has occurred. Please check console."; }
            console.log(err);
            if (err.response === undefined) {
                reject({ type: "error", message: errMsg });
            }
            else if (err.response.status === 419 || err.response.status === 401) {
                reject({
                    type: "timeout",
                    message: "Session expired. Please Login again.",
                });
            }
            else {
                var msg = err.message;
                if (err.response && err.response.data && err.response.data.message) {
                    msg = err.response.data.message;
                }
                reject({ type: "error", message: msg });
            }
        };
        this.getActiveAccount = function () { return _this.store.Session.get(SESSION_KEYS.ACTIVE_ACCOUNT); };
        this.cachedResponse = function (unset, key, servercall, params) {
            if (unset === void 0) { unset = false; }
            if (params === void 0) { params = []; }
            console.debug("cache age of key ".concat(key, ":"), _this.store.Cache.getCacheAge(key));
            var unsetCheck = Promise.resolve(unset);
            return new Promise(function (resolve, reject) {
                return unsetCheck
                    .then(function (condition) {
                    if (condition) {
                        return _this.store.Cache.unsetAsync(key).then(function () {
                            return true;
                        });
                    }
                    else
                        return true;
                })
                    .then(function () {
                    return _this.store.Cache.getAsync(key);
                })
                    .then(function (cachedVal) {
                    console.debug("Cached key FOUND for key ".concat(key));
                    resolve(cachedVal);
                })
                    .catch(function (err) {
                    // console.warn(err)
                    console.debug("Cached value did NOT found for key ".concat(key, "; fetching from server"));
                    return servercall.apply(void 0, params).then(function (value) {
                        console.debug("setting cache item: ".concat(key));
                        return _this.store.Cache.setAsync(key, value);
                    })
                        .then(function (cachedVal) {
                        console.debug("resolving cache item");
                        resolve(cachedVal);
                    })
                        .catch(function (err2) { return reject(err2); });
                });
            });
        };
        this.prepareObjectForSaving = function (_obj) {
            if (_obj === void 0) { _obj = {}; }
            var out = {};
            console.debug('_obj', _obj);
            var _keys = Object.keys(_obj);
            for (var _i = 0, _keys_1 = _keys; _i < _keys_1.length; _i++) {
                var key = _keys_1[_i];
                var _field = _obj[key];
                if (_field.rules) {
                    // store default year
                    var _value = _field.value;
                    // If the type is number; try to convert it to number
                    if (_field.rules.isNumber) {
                        try {
                            _value = Number(_obj[key].value);
                        }
                        catch (error) {
                            console.error(error);
                        }
                    }
                    out[key] = _value;
                }
            }
            console.debug('out', out);
            return out;
        };
        // this.comp = callerComponent;
        // this.props = this.comp.props;
        // this.nav = new Navigator(callerComponent);
        // this.cache = WebClientStore.Cache;
        // this.silentMode = false;
        // this.URLs = URLs;
        this.store = WebClientStore;
        // this.session = WebClientStore.Session;
        this.instance = AxiosSingleton.getInstance();
    }
    ApiHandler.prototype.standardGetOperation = function (url) {
        var _this = this;
        var _a, _b;
        try {
            console.debug((_b = (_a = new Error().stack) === null || _a === void 0 ? void 0 : _a.split("\n")[2]) === null || _b === void 0 ? void 0 : _b.trim().split(" ")[1]);
        }
        catch (error) {
            //
        }
        console.debug("Get:", url);
        return new Promise(function (resolve, reject) {
            _this.getInstance()
                .get(url)
                .then(function (response) {
                resolve(response);
            })
                .catch(function (err) {
                _this.handleError(err, "An error occurred while calling service url [".concat(url, "]. Please try again."));
                reject("An internal error occurred while calling server. Please try again later.");
            });
        });
    };
    ApiHandler.prototype.standardPatchOperation = function (url, payload) {
        var _this = this;
        var _a, _b;
        try {
            console.debug((_b = (_a = new Error().stack) === null || _a === void 0 ? void 0 : _a.split("\n")[2]) === null || _b === void 0 ? void 0 : _b.trim().split(" ")[1]);
        }
        catch (error) {
            //
        }
        console.debug("Patch:", url, payload);
        return new Promise(function (resolve, reject) {
            _this.getInstance()
                .patch(url, payload)
                .then(function (response) {
                resolve(response);
            })
                .catch(function (err) {
                return _this.handleError(err, "An error occurred while patching on url [".concat(url, "]. Please try again."));
            });
        });
    };
    return ApiHandler;
}());
export default ApiHandler;
//# sourceMappingURL=ApiHandler.js.map